export default __webpack_public_path__ + "static/media/chart-options-icon.9abd9b99.svg";